import { forwardRef, InputHTMLAttributes, useState } from 'react';
import './input.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  id: string;
  type?: string;
  value: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  editable?: boolean;
  style?: React.CSSProperties;
  error?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, id, type = 'text', value, onChange, editable = false, style, error, ...props },
  ref,
) {
  const [inputType, setInputType] = useState(type);

  const togglePasswordVisability = () => {
    setInputType((prev) => (prev == 'password' ? 'text' : 'password'));
  };

  return (
    <div className="input__container" style={{ ...style }}>
      {label && (
        <label htmlFor={id} className="input__label">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={id}
        type={inputType}
        value={value}
        onChange={onChange}
        {...props}
        className={`input__field ${editable ? 'active' : ''} ${error ? 'error' : ''}`}
        disabled={!editable}
        style={{ position: 'relative' }}
      />
      {error && <div className="input__error">{error}</div>}
      {type && type == 'password' && editable ? (
        <button className="show-password show-password__admin" type="button" onClick={togglePasswordVisability}>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.625 7.5C0.625 7.5 3.125 2.5 7.5 2.5C11.875 2.5 14.375 7.5 14.375 7.5C14.375 7.5 11.875 12.5 7.5 12.5C3.125 12.5 0.625 7.5 0.625 7.5Z"
              stroke="#1D61E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 9.375C8.53553 9.375 9.375 8.53553 9.375 7.5C9.375 6.46447 8.53553 5.625 7.5 5.625C6.46447 5.625 5.625 6.46447 5.625 7.5C5.625 8.53553 6.46447 9.375 7.5 9.375Z"
              stroke="#1D61E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ) : undefined}
    </div>
  );
});

export default Input;
